import { isDefined } from '@pflegia/util/common/type-guards';

import { BaseFunnelAnswers, BaseFunnelJobTitle, LocalFunnelStep } from '../types';
import { isAnswered } from './is-answered';

/**
 * Returns next question to be answered starting from index `from`.
 *
 * Skips questions which have been answered or their condition returns false.
 * Returns -1 when no eligible unanswered step exists (index 0 stays a valid step).
 */
export const getNextQuestionIndex = <
  J extends BaseFunnelJobTitle = BaseFunnelJobTitle,
  A extends BaseFunnelAnswers<J> = BaseFunnelAnswers<J>,
  Q extends string = string,
  P = undefined,
>(
  questions: LocalFunnelStep<J, A, Q, P>[],
  answers: A,
  jobTitles: J[],
  from = 0,
  props: P,
) => {
  for (let i = from; i < questions.length; i++) {
    const { condition, conditionOveride } = questions[i];
    const conditionOveridden = isDefined(conditionOveride) ? conditionOveride(answers, jobTitles, props) : false;
    if (!conditionOveridden && isAnswered(answers, questions[i].key as keyof A)) continue;

    if (!condition || condition(answers, jobTitles, props) || conditionOveridden) {
      return i;
    }
  }
  return -1;
};
